import React, { useId } from "react";

interface CheckboxOption {
  value: string;
  label: string;
}

interface CheckboxGroupProps {
  label: string;
  options: CheckboxOption[];
  value: string[];
  onChange: (value: string[]) => void;
  disabled?: boolean;
  inline?: boolean;
}

const CheckboxGroup: React.FC<CheckboxGroupProps> = ({ label, options, value, onChange, disabled = false, inline = false }) => {
  const groupId = useId();
  const labelSt: React.CSSProperties = { fontSize: "12px", fontWeight: 500, color: "var(--t2, #5A6178)", fontFamily: "var(--font-primary, DM Sans, sans-serif)", lineHeight: "16px", marginBottom: "4px" };

  const handleToggle = (optValue: string) => {
    if (disabled) return;
    const next = value.includes(optValue) ? value.filter((v) => v !== optValue) : [...value, optValue];
    onChange(next);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "6px", width: "100%" }}>
      <span style={labelSt}>{label}</span>
      <div style={{ display: "flex", flexDirection: inline ? "row" : "column", flexWrap: inline ? "wrap" : undefined, gap: "8px" }}>
        {options.map((opt) => {
          const isChecked = value.includes(opt.value);
          const optId = `${groupId}-${opt.value}`;
          return (
            <label key={opt.value} htmlFor={optId} style={{ display: "flex", alignItems: "center", gap: "10px", cursor: disabled ? "not-allowed" : "pointer", padding: "8px 12px", borderRadius: "8px", border: isChecked ? "1px solid var(--accent, #D23A3B)" : "1px solid var(--card-border, #E2E5EC)", backgroundColor: isChecked ? "var(--accent-soft, rgba(210, 58, 59, 0.04))" : "var(--surface, #FFFFFF)", transition: "all 0.15s ease" }}>
              <div style={{ width: "18px", height: "18px", borderRadius: "4px", border: isChecked ? "none" : "2px solid var(--card-border, #E2E5EC)", backgroundColor: isChecked ? "var(--accent, #D23A3B)" : "transparent", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, transition: "all 0.15s ease" }}>
                {isChecked && (
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M2.5 6L5 8.5L9.5 3.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                )}
              </div>
              <input type="checkbox" id={optId} checked={isChecked} onChange={() => handleToggle(opt.value)} disabled={disabled} style={{ position: "absolute", opacity: 0, width: 0, height: 0 }} />
              <span style={{ fontSize: "13px", fontWeight: 500, color: "var(--t1, #1A1D2E)", fontFamily: "var(--font-primary, DM Sans, sans-serif)" }}>{opt.label}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default CheckboxGroup;
